export default __webpack_public_path__ + "static/media/notificationSound.440284d0.mp3";